export const CLIENT_CONTENT_READY_EVENT = 'trellis:client-content-ready'

declare global {
  interface Window {
    __trellisClientContentReady?: boolean
  }
}

export function markClientContentReady() {
  if (window.__trellisClientContentReady) {
    return
  }
  window.__trellisClientContentReady = true
  window.dispatchEvent(new Event(CLIENT_CONTENT_READY_EVENT))
}
